fabric.LineArrow = fabric.util.createClass(fabric.Line, {
	type: "lineArrow",

	initialize: function (element, options) {
		options || (options = {});
		this.callSuper("initialize", element, options);
	},

	toObject: function () {
		return fabric.util.object.extend(this.callSuper("toObject"));
	},

	_render: function (ctx) {
		this.callSuper("_render", ctx);

		const xDiff = this.x2 - this.x1;
		const yDiff = this.y2 - this.y1;

		//this might be usefull to fix rendering problems with strokeWidht > 50
		//coordinates start (x=0, y=0) at left top corner 
		// if (xDiff > this.strokeWidth && yDiff < -1 * this.strokeWidth)
		// 	if (this.x1 < this.x2 && this.y1 > this.y2) {
		// 		this.x2 = this.x2 + (this.strokeWidth);
		// 		this.y2 = this.y2 - (this.strokeWidth);
		// 	} else {
		// 		this.x2 = this.x2 - (this.strokeWidth);
		// 		this.y2 = this.y2 + (this.strokeWidth);
		// 	}


		const mod = n => {
			return n ? ((this % n) + n) % n : 0;
		};

		// do not render if diff between X or Y less than stroke with or object is not visible
		if (
			(mod(xDiff) < this.strokeWidth && mod(yDiff) < this.strokeWidth) ||
            !this.visible
		) return;

		var angle = Math.atan2(yDiff, xDiff);

		ctx.save();
		ctx.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2);
		ctx.rotate(angle);
		ctx.beginPath();
		//move 10px in front of line to start the arrow so it does not have the square line end showing in front (0,0)

		ctx.moveTo(1 * this.strokeWidth, 0);
		ctx.lineTo(-1 * (3 * this.strokeWidth), 2 * this.strokeWidth);
		ctx.lineTo(-1 * (3 * this.strokeWidth), -1 * (2 * this.strokeWidth));
		ctx.closePath();
		ctx.fillStyle = this.stroke;
		ctx.fill();

		ctx.restore();
	}
});

fabric.LineArrow.fromObject = function (object, callback) {
	callback &&
        callback(
        	new fabric.LineArrow([object.x1, object.y1, object.x2, object.y2], object)
        );
};

fabric.LineArrow.async = true;
